export var notUndefined = function notUndefined(x) {
  return !!x;
};
export var clearAllFocus = function clearAllFocus() {
  if (document.activeElement instanceof HTMLElement) {
    document.activeElement.blur();
  }
};
export var debounce = function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    var context = this;
    var args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) {
      func.apply(context, args);
    }
  };
};
export var convertDateFormatToSlashes = function convertDateFormatToSlashes(date) {
  return date.replace(/-/g, '/');
};